import React from 'react';
import styled from 'astroturf/react';
import { Image } from 'js/social/shared/types';
import { PostImage } from 'js/social/shared/PostImage';
import routes from 'sitewide-js/core_pre_webpack/routes';

const Container = styled.div<{
  hoisted?: boolean;
  quoted?: boolean;
  nested?: boolean;
}>`
  @import 'stylesheets/design_system/_deprecated_grid.scss';
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 16px 8px 16px;
  background: $ds-white;

  &.quoted {
    margin: 8px;
    padding: 8px;
    border: 1px solid #ebebee;
    border-radius: 6px;
    cursor: pointer;
  }

  &.nested {
    padding: 8px;
    border: 1px solid #ebebee;
    border-radius: 6px;
  }

  &.hoisted {
    border: 2px solid $ds-primary-blue-active;
  }

  @include medium-up {
    border-radius: 6px;

    &:not(.hoisted) {
      border: 1px solid #ebebee;
    }
  }
`;

const DesktopQuoteImageOnSide = styled.div`
  display: none;

  @include for-tablet-up {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const HeaderAndContentContainer = styled.div``;

const ImageContainer = styled.div`
  width: 130px;
  flex-shrink: 0;
  padding-left: 16px;
`;

const DisplayOnMobile = styled.div`
  display: block;
  @include for-tablet-up {
    display: none;
  }
`;
interface Props {
  className?: string;
  reason?: React.ReactNode;
  header: React.ReactNode;
  content: React.ReactNode;
  cta?: React.ReactNode;
  hoisted?: boolean;
  isQuotedNews?: boolean;
  image?: Image;
  isSinglePostPage?: boolean;
  newsType?: string;
  newsId?: string | number;
  looksDeleted?: boolean;
  nested?: boolean;
}

const Base: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  reason,
  header,
  content,
  cta,
  children,
  hoisted,
  isQuotedNews,
  image,
  isSinglePostPage,
  newsType,
  newsId,
  looksDeleted,
  nested = false,
}) => {
  const handleContainerClick = (event: React.MouseEvent<HTMLDivElement>) => {
    // !event.target.classList.contains('clickable');
    const target = event.target as HTMLElement;
    if (
      isQuotedNews &&
      target.tagName !== 'A' &&
      // adding 'clickable' to the bottom level of className for
      // (e.g. '...see more' and images) prevents redirect
      !target.classList.contains('clickable') &&
      // prevent lightbox popover clicks from redirecting to single
      // post page
      !target.className.startsWith('yarl')
    ) {
      window.location.href =
        newsType === 'post'
          ? routes.community_show_post_url({ post_id: newsId })
          : routes.community_show_paper_update_url({
              paper_update_id: newsId,
            });
    }
  };
  return (
    <Container
      className={className}
      hoisted={hoisted}
      quoted={isQuotedNews}
      nested={nested}
      onClick={handleContainerClick}
    >
      {reason}
      {isQuotedNews && !isSinglePostPage && !looksDeleted && image ? (
        <>
          <DesktopQuoteImageOnSide>
            <HeaderAndContentContainer>
              {header}
              {content}
            </HeaderAndContentContainer>
            <ImageContainer>
              <PostImage image={image} />
            </ImageContainer>
          </DesktopQuoteImageOnSide>
          <DisplayOnMobile>
            {header}
            {content}
          </DisplayOnMobile>
        </>
      ) : (
        <>
          {header}
          {content}
        </>
      )}
      {cta}
      {children}
    </Container>
  );
};

export default Base;
